import React, { useRef } from 'react'

const OTPInput = ({ length = 4, onChange, onComplete }) => {
  const [otp, setOtp] = React.useState(''.padEnd(length, ''))
  const inputsRef = useRef([])

  const handleChange = (idx, value) => {
    if (value.length > 1) value = value.slice(-1)
    const newOtp = otp.split('')
    newOtp[idx] = value
    const otpString = newOtp.join('')
    setOtp(otpString)
    if (onChange) onChange(otpString)
    if (value && idx < length - 1) {
      inputsRef.current[idx + 1]?.focus()
    }
    if (otpString.length === length && !otpString.includes('')) {
      if (onComplete) onComplete(otpString)
    }
  }

  const handleKeyDown = (idx, e) => {
    if (e.key === 'Backspace' && !otp[idx] && idx > 0) {
      inputsRef.current[idx - 1]?.focus()
    }
  }

  return (
    <div className="flex gap-3">
      {Array.from({ length }).map((_, idx) => (
        <input
          key={idx}
          ref={(el) => (inputsRef.current[idx] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={otp[idx] || ''}
          onChange={(e) => handleChange(idx, e.target.value)}
          onKeyDown={(e) => handleKeyDown(idx, e)}
          className="w-12 h-12 text-center text-lg font-medium border border-gray-300 rounded bg-secondary-50 text-foreground placeholder:text-medium-opacity focus:outline-none focus:border-secondary-600 focus:ring-2 focus:ring-secondary-600/20 transition-colors"
        />
      ))}
    </div>
  )
}

export default OTPInput
